import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './HowItWorks.css';

const HowItWorks = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const steps = [
    {
      number: 1,
      title: '📲 Sign Up & Verify',
      description: 'Download the app, create your account, and verify your identity. Link your bank account for seamless investing. Takes less than 5 minutes!'
    },
    {
      number: 2,
      title: '🎯 Choose Your Path',
      description: 'Renter? Start building equity in your building. Investor? Browse properties and start buying shares in real estate across the country. Both paths lead to wealth!'
    },
    {
      number: 3,
      title: '📈 Watch Your Wealth Grow',
      description: 'Track your portfolio in real-time. Earn dividends from rental income and benefit from property appreciation. Trade shares anytime on our secondary marketplace.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.4
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="how-it-works" className="how-it-works" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="migra-font">How GusHome Works</h2>
          <p>Three simple steps to start building real estate wealth today</p>
        </motion.div>
        
        <motion.div 
          className="steps-container"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              className="step"
              variants={itemVariants}
              transition={{ duration: 0.6 }}
            >
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
